var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design-system",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    transform: "translate(-685.000000, -84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(685.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#E6ECFF",
    fillRule: "nonzero",
    cx: 15.971187,
    cy: 16.0273871,
    rx: 10.3032334,
    ry: 10.303304
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2088064,17.6462651 L17.1159908,15.5533206 L17.1159908,12.5929524 C17.1159908,11.9606905 16.6034447,11.4481409 15.971187,11.4481409 C15.3389294,11.4481409 14.8263833,11.9606905 14.8263833,12.5929524 L14.8263833,16.0273871 C14.8280698,16.3311421 14.9488325,16.6221174 15.1627267,16.8377992 L17.5897105,19.2647997 C18.0389073,19.6986515 18.7529281,19.6924468 19.1945176,19.2508543 C19.6361071,18.8092618 19.6423118,18.095236 19.208463,17.6460362 L19.2088064,17.6462651 Z",
    id: "Path",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.971187,0 C15.3389294,0 14.8263833,0.512574886 14.8263833,1.14483685 C14.8263833,1.77709882 15.3389294,2.28964841 15.971187,2.28964841 C22.5814779,2.26232404 28.2820323,6.92806426 29.5620125,13.4133491 C30.8419927,19.8986339 27.3415795,26.3803649 21.2165954,28.8665961 C15.0916112,31.3528272 8.06386918,29.1446464 4.46159079,23.6020204 C0.85931239,18.0593944 1.69514518,10.7404278 6.45431934,6.15270053 L6.37670164,6.74479707 C6.29450816,7.37181125 6.73616912,7.94673812 7.363179,8.02893217 C7.99018889,8.11112623 8.56511182,7.66946225 8.64730532,7.04244807 L9.09286292,3.63709161 C9.15901762,3.01439298 8.72451937,2.44948595 8.10569868,2.35364337 L4.70036557,1.90842616 C4.28892041,1.84299139 3.8744091,2.00624337 3.61808279,2.33467461 C3.36175649,2.66310584 3.30408631,3.10486063 3.46750683,3.4880897 C3.63092736,3.87131877 3.98963626,4.13551443 4.40409037,4.17790059 L5.11695964,4.27131721 C-0.521194955,9.50317313 -1.63851139,18.0066669 2.45671826,24.5174582 C6.55194792,31.0282496 14.7005745,33.7034679 21.8579489,30.8869399 C29.0153232,28.070412 33.1555603,20.559352 31.7155234,13.0037048 C30.2754865,5.44805758 23.6627762,-0.0135613909 15.971187,0 Z",
    id: "Path",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2109815,19.2672038 C18.7594692,19.7097652 18.0368726,19.7097652 17.5853603,19.2672038 L15.1583764,16.8402033 C15.0548965,16.730746 14.9732956,16.6025152 14.9179676,16.4624155 C14.9179676,16.4509674 14.9065196,16.4509674 14.9065196,16.4395193 C15.6277459,16.1647645 16.3604203,15.8556654 17.1159908,15.52367 L17.1159908,15.5580144 L19.2109815,17.6415714 C19.6574297,18.0914914 19.6574297,18.8172838 19.2109815,19.2672038 L19.2109815,19.2672038 Z",
    id: "Path",
    fill: "#1A73E8"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncClock);
export default __webpack_public_path__ + "static/media/sync-clock.f25b398a8f82fd94025fef0251c1c830.svg";
export { ForwardRef as ReactComponent };